import { render, staticRenderFns } from "./form-base.vue?vue&type=template&id=0c22caba&"
import script from "./form-base.vue?vue&type=script&lang=js&"
export * from "./form-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports